/* eslint-disable import/prefer-default-export */
import React from 'react';
import {Badge} from '@albert-io/atomic';

/**
 * @example
 * [badge]Topic[/badge]
 * [badge color=<color>]Topic[/badge]
 */
const regex = /^\[badge(?:\s+color=(passive|emphasized|progress|success|danger))?]((?:[\w\W](?!\[\/badge\]))+[\w\W])\[\/badge\]/;

export const badgeRule = {
  order: 0.1,
  match: (source) => regex.exec(source),
  parse: (capture, recurseParse, state) => {
    // eslint-disable-next-line no-unused-vars
    const [_, color, content] = capture;
    return {
      content: recurseParse(content, state),
      color
    };
  },
  react(node, output) {
    return (
      <Badge key={node.tokenId} color={node.color || 'progress'}>
        {output(node.content)}
      </Badge>
    );
  }
};
